<template>
    <template v-if="!$settings.isQuote">
        <!-- Pagine login e pubbliche senza layout -->
        <template v-if="isLayoutlessRoute">
            <router-view />
        </template>

        <!-- Pagine autenticate con AdminLayout -->
        <template v-else-if="$cookies.get('admin_token')">
            <AdminLayout :key="adminLayoutKey">
                <router-view />
            </AdminLayout>
        </template>
    </template>

    <FlashMessages
        :bottom="(($settings.isQuote || $settings.isFront) && $settings.isLoggedIn)?'60px':'0px'"
        v-model="flashMessages"
    />

    <LoadingOverlay v-if="overlayVisibility"></LoadingOverlay>

    <template v-if="$settings.isQuote && $settings.isLoggedIn">
        <QuoteBar></QuoteBar>
    </template>

</template>

<script setup>
import { useLoadingOverlayStore } from '@/composables/useLoadingOverlayStore.js'
import { useFlashMessagesStore } from '@jinkosoft/flash-messages'
import { storeToRefs } from 'pinia';

import { useRouter, useRoute } from 'vue-router';

import AdminLayout from '@/layouts/AdminLayout.vue'
import QuoteBar from "@/components/front/quote/QuoteBar.vue";
import {useGlobals, useMutation} from "@/composables/useGlobals.js";
import {computed, inject, onMounted} from "vue";
import VueCookies from "vue-cookies";

const {
    gql,
} = useGlobals()

const settings                  = inject("$settings")

const router                    = useRouter();
const route                     = useRoute();

const loadingOverlayStore       = useLoadingOverlayStore()
const { overlayVisibility }     = storeToRefs(loadingOverlayStore)

const { 
    flashMessages, 
    setMessageDuration 
}     = useFlashMessagesStore()

const adminAuthStore        = useAdminAuthStore()

const adminLayoutKey = computed(() => String(route.params.tenantId || 'guest'))
const isLayoutlessRoute = computed(() => route.name === 'login' || route.name === 'auth.callback' || route.meta?.public === true)

setMessageDuration(1000)

router.beforeEach((to, from, next) => {

    document.querySelectorAll('.uk-modal').forEach((el) => {
        if (el.id !== 'modal-menu') {
            el.remove()
        }
    })

    if (!VueCookies.get('admin_token') && !['login', 'auth.callback'].includes(to.name) && to.meta?.public !== true) {
        next({ name: 'login', query: { redirect: to.fullPath } })
        return
    }

    next()
})

router.afterEach(() => {

})

const { mutate: askLogout } = useMutation(gql`
    mutation logout{
        adminLogout
    }
`)


const logout = async () => {

    const result        = await askLogout()

    if(result?.data?.adminLogout){

        adminAuthStore.clearAdmin()

        VueCookies.remove('admin_token')

        await router.push({ name: "login" })
    }

    console.log(result)
}

onMounted(async () => {

    if(!VueCookies.get('admin_token') && !['login', 'auth.callback'].includes(route.name) && route.meta?.public !== true) {
        await router.push({ name: 'login', query: { redirect: route.fullPath } })
    }
})
</script>
